import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { KioskInputType } from 'hooks/kiosk/useKiosk';
import { getMonthNames } from 'utils/dateUtil';
import {
  KioskChoiceGrid,
  KioskEntryButton,
  KioskEntryMessageBoxStyled,
  KioskMonthButton,
  KioskRowGroup,
} from 'containers/public/kiosk/Kiosk.styled';
import { KioskLayout } from 'containers/public/kiosk/KioskLayout';

const MONTH_NAMES = getMonthNames();

// Design px. The longest month name, SEPTEMBER, needs this width at --fontlg.
const MIN_WIDTH_TO_HOLD_MONTH_NAME = 330;

export const KioskEntryBirthMonth = ({
  onMonthSelected,
  onDifferentInputClicked,
}: {
  onMonthSelected: (month: number) => void;
  onDifferentInputClicked: (inputType: KioskInputType) => void;
}) => {
  const { t } = useCommonTranslation();

  return (
    <KioskLayout>
      <KioskEntryMessageBoxStyled>
        <div>{t('kiosk-checkin-birth-month-hint')}</div>
        <KioskChoiceGrid
          $maxColumns={4}
          $minColumnWidth={MIN_WIDTH_TO_HOLD_MONTH_NAME}
        >
          {MONTH_NAMES.map((monthName, idx) => (
            <KioskMonthButton
              key={monthName}
              type="button"
              onClick={() => onMonthSelected(idx + 1)}
            >
              {monthName}
            </KioskMonthButton>
          ))}
        </KioskChoiceGrid>

        <KioskRowGroup>
          <KioskEntryButton
            type="button"
            variant="secondary"
            onClick={() => onDifferentInputClicked('PHONE')}
          >
            {t('kiosk-checkin-phone-number')}
          </KioskEntryButton>
        </KioskRowGroup>
      </KioskEntryMessageBoxStyled>
    </KioskLayout>
  );
};
